// import {toastr} from 'components/toastr';
import querystring from 'querystring';
import {isAndroid, isIOS, isMobile} from 'react-device-detect';

import {scheme} from '@afreecatv/domains';
import axios from 'axios';
import {inAppStore} from './event/util';
import globalDomains from './global-domains';
import {bridgeHandler} from '@/app/(events)/events/soopi/utils/bridgeHandler';
import ItemMobileApi from '@/api/item_m';
import checkDevice from '@/app/(events)/events/soopi/utils/checkDevice';
import LiveApi from '@/api/live';
import {CommonT} from '@/utils/i18n/common';

export const isWebview = (() => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const uagent = window.navigator.userAgent.toLocaleLowerCase();
    return uagent.indexOf('afreeca webview') > -1 ||
      uagent.indexOf('afreeca up webview') > -1 ||
      uagent.indexOf('sooplive webview') > -1 ||
      uagent.indexOf('sooplive up webview') > -1
      ? true
      : false;
  }
})();

/**
 * 인앱 결제 가능 여부 app 내 header
 * @param {*} duration
 */
export const inAppPlayStore = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const ua = window.navigator.userAgent;
    const isPlayStore = /isPlayStore=([yYnN]);?/gi.exec(ua) || '';

    return isPlayStore !== '' ? isPlayStore[1].toUpperCase() : '';
  }
};

export const getAppVersion = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    var aMatch = window.navigator.userAgent
      .toLocaleLowerCase()
      .match(/(afreeca|sooplive) webview2?\/([0-9.]+)/);
    return aMatch ? aMatch[2] : '1.0.0';
  }
};

/**
 * 구글 플레이스토어
 * inApp 결제 활성화 여부 체크
 */
export const getActiveInAppPayment = async () => {
  // 인앱 결제 활성화 체크 여부 확인
  const params = {
    work: 'IN_APP',
    type: 'subscription',
    os: 'android',
    version: getAppVersion(),
  };

  // 소문자로 변경..
  const {result = -1, data = false} = await LiveApi.get(
    `/api/item_info/index.php`,
    params,
  );

  if (result !== 1) {
    return false;
  }

  return data;
};

export const getSysType = () => {
  if (isMobile) {
    return isIOS ? 'ios' : 'aos';
  } else {
    return 'web';
  }
};

/**
 * 구독하기
 * @param {*} bj_id
 */
export const popupSubscription = async ({
  bj_id,
  bj_profile_image,
  user_id,
  bj_nick,
  location = 'soopi_event_subspopup',
  tierType = 1,
  notWindowOpen = false,
}) => {
  if (!isWebview) {
    // 웹
    const popup = window.open(
      `${globalDomains.ST_AFREECATV}/app/gift_subscription.php?bjId=${bj_id}&sysType=${getSysType()}&location=${location}&tierType=${tierType}`,
      'gift_popup',
      'width=320,height=240,scrollbars=yes',
    );

    return popup;
  } else {
    popupSubscriptionMobile({
      bj_id,
      bj_profile_image,
      user_id,
      bj_nick,
      notWindowOpen,
    });

    return null;
  }
};

/**
 * 구독하기 인앱결제
 * @param {*} bj_id
 * @returns
 */
export const popupSubscriptionMobile = async ({
  bj_id,
  bj_profile_image,
  user_id,
  bj_nick,
  notWindowOpen,
}) => {
  /*
   * AOS(기존) iOS(신규) 구독 버튼 추가 및 구독 페이지 UI 연결
   * 공통 파라미터 : receiverId, receive_nick, iOS : bj_image (프로필 이미지)
   */

  try {
    /**
     * 구독 flow
     * 1. 선물받은 구독권 보유 여부(api/subscription/a/info) 확인
     * 2. 없을 경우 마켓, 인앱 결제 활성화 체크
     * 3. 활성화 여부 Y 일 경우 구독 스킴 open
     */

    /**
     * 22-03-04 Google InApp 결제 작업에서 Android도 bj_image 추가
     * 구독 정보 API(subscription/a/info) Android 앱 내부에서도 호출 하고 있어 제거 예정. is_subscribe 파라미터 추가
     */
    // SUBSCRIPTION_URL
    let subscription_url = `${scheme.SERVICE_APP_SCHEME}item/subscription?receiverId=${bj_id}&receive_nick=${encodeURIComponent(bj_nick)}&bj_image=${encodeURIComponent(bj_profile_image)}`;

    /* if (isIOS) {
            let url = "https:" + profile_image;
            subscription_url += `&bj_image=${encodeURIComponent(url)}`;
        } */
    const {result = -1, data = []} = await ItemMobileApi.post(
      `/api/subscription/a/info`,
      querystring.stringify({bj_id: bj_id}),
    );

    const {
      subscription_type = '',
      subscription_ticket_type = '',
      first_payment_date = '',
      expire_payment_date = '',
      rest_payment_date = 0,
      hold_flag = 0,
      prod_name = '',
      svc_coupon = '',
      message = '',
    } = data;
    /**
     * subscription_type: auto 자동결제 / ticket: 구독한 경우
     * hold_flag: 선물받은 구독권 유무 0(없음) 1(있음)
     */

    // 오류 발생 시
    if (result === -1) {
      if (checkDevice() === 'Web') {
        alert(message);
      } else {
        bridgeHandler('THROW_TOAST', {
          msg: message,
        });
      }
    }

    if (result === -1102) {
      const {regist_date = '', regist_term_date = ''} = data;
      let msg = CommonT(
        `{{userNick}}님은 서비스 이용이 정지되어\n구독할 수 없습니다.\n\n`,
        {placeholder: {userNick: user_nick}},
      );
      msg += CommonT('정지일') + ` : `;
      msg += `${regist_date}\n`;
      msg += CommonT('해제일') + ` : `;
      msg += `${regist_term_date}`;

      if (checkDevice() === 'Web') {
        alert(msg);
      } else {
        bridgeHandler('THROW_TOAST', {
          msg,
        });
      }
    }

    /**
           월 정기결제, 정기 구독권 : 얼럿 미노출 및 구독페이지 이동 o
         */

    // AOS 일 경우에 인앱 결제 어드민 요청
    if (isAndroid) {
      const isActiveInApp = (await getActiveInAppPayment()) || false;
      const isPlayStore = inAppPlayStore();
      const store = inAppStore();
      subscription_url +=
        `&activeInApp=` +
        (isActiveInApp && isPlayStore === 'Y' ? 'true' : 'false');
      subscription_url +=
        `&isSubscribed=` +
        (subscription_type === null || subscription_type === ''
          ? 'false'
          : 'true');

      if (store) {
        subscription_url += `&store=` + store;
      }
    }

    // 자동 결제 OR 선물 받은 구독권이 없을 경우
    if (subscription_type === 'auto' || hold_flag === 0) {
      // InApp 여부에 따른 구독 스킴 ON/OFF
      if (isIOS && !notWindowOpen) {
        window.open(subscription_url);
      } else {
        window.location.href = subscription_url;
      }
      return;
    }

    // 선물받은 구독권이 있을 경우
    let msg = '';
    if (subscription_type === 'ticket') {
      msg = CommonT(
        `{{userNick}}님에게 사용 가능한 선물 받은 구독권을 보유중입니다.\n\n`,
        {
          placeholder: {
            userNick: user_nick,
          },
        },
      );

      msg += CommonT('이용중인 구독권') + ` : `;
      msg += `${subscription_ticket_type}\n`;
      msg += CommonT('구독 기간') + ` : `;
      msg += `${first_payment_date} ~ ${expire_payment_date}\n`;
      msg +=
        CommonT(`(잔여일수 : {{restPaymentDate}}일)`, {
          placeholder: {
            restPaymentDate: rest_payment_date,
          },
        }) + `\n`;
      msg += CommonT('사용해서 구독하시겠습니까?') + `\n\n`;
      msg += CommonT('사용할 구독권') + ` : `;
      msg += `${prod_name}`;
    } else {
      msg = CommonT(
        `{{userNick}} 님에게 사용 가능한 구독권을 보유 중입니다\n사용 하시겠습니까?\n\n`,
        {
          placeholder: {userNick: user_nick},
        },
      );
      msg += CommonT('사용할 구독권') + ` : `;
      msg += `${prod_name}`;
    }

    // 선물 받은 구독권 사용
    if (!window.confirm(msg)) {
      window.location.href = subscription_url;
      return;
    }

    const {result: useResult = -1, data: useData = []} = await fetchJson(
      `${globalDomains.ITEM_M_AFREECATV}/api/subscription/a/giftUse`,
      {
        method: 'post',
        credentials: 'include',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: querystring.stringify({
          send_id: user_id,
          recv_id: global.bj_id,
          svc_coupon,
          location: 'station',
        }),
      },
    );
    const {
      message: useMessage = '',
      item_name = '',
      period = '',
      remain_days = 0,
    } = useData;

    // 오류 발생 시
    if (useResult === -1) {
      throw new Error(useMessage);
    }

    msg = CommonT(
      `{{userNick}}님에게\n선물 받은 구독권을 사용하였습니다.\n\n`,
      {
        placeholder: {
          userNick: user_nick,
        },
      },
    );

    msg += CommonT('이용중인 구독권') + ` : `;
    msg += `${item_name}\n`;
    msg += CommonT('구독 기간') + ` : `;
    msg += `${period}\n`;
    msg += CommonT(`(잔여일수 : {{remainDays}}일)`, {
      placeholder: {
        remainDays: remain_days,
      },
    });
  } catch (error) {
    // toastr.error(error.message, {
    //   timeOut: 2000,
    // });
  }
};

/**
 * event_auto_hashtag / 이벤트 등의 사유로 서버에서 내려주는 태그의 스타일을 파싱하는 함수
 *
 * @param {string} tag 스타일 적용하고자 하는 태그 이름
 * @param {Array} data 서버에서 내려준 스타일 배열
 * @param {'dark' | 'light'} theme 전역 스타일 테마
 * @param {'style' | 'hover'} type 직접 스타일인지 혹은 이벤트 발생 시 스타일인지
 * @returns {React.CSSProperties | undefined}
 */
// TODO: ChipCategory에 정의된 함수는 충돌 방지용으로 남겨둠
export const generateStyle = (tag, data, theme, type) => {
  try {
    if (tag && data) {
      const element = data?.filter((val) => tag === val.tagName);

      if (element.length > 0) {
        const {event, style} = element[0][theme].pc || {};
        if (type === 'style') {
          return style;
        } else {
          // 마우스 호버 등 이벤트 발생 시 스타일
          return event[type];
        }
      }
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};
